export default "__VITE_ASSET__89749e61__"